import type { RegionParameters } from '@innovamat/glow-api-client';

type Props = {
  number: number | null | undefined;
  fixedTo?: number;
  forceDecimals?: boolean;
  parameters?: RegionParameters;
};

const getRegionalNumber = ({
  number,
  fixedTo = 1,
  forceDecimals = false,
  parameters,
}: Props): string | undefined => {
  if (number === undefined || number === null) {
    return undefined;
  }

  const thousandSeparator = parameters?.thousandSeparator || ' ';
  const decimalSeparator = parameters?.decimalSeparator || ',';
  const divisionSign = parameters?.shortDivisionSign || '/';

  const formattedNumber = number.toFixed(
    number % 1 === 0 && !forceDecimals ? 0 : fixedTo
  );

  const [integerPart, decimalPart] = formattedNumber.split('.');

  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    thousandSeparator
  );

  let result = formattedIntegerPart;
  if (decimalPart) {
    result += decimalSeparator + decimalPart;
  }

  result = result.replace(/\//g, divisionSign);

  return result;
};

export { getRegionalNumber };
